module.exports = __webpack_public_path__ + "img/right-side-icon.31a2b880.svg";